export enum Theme {
	LIGHT = 'light',
	DARK = 'dark',
	AUTO = 'auto',
}
